import { Button } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { AuctionDetailButtonProps } from './interface'

export const AuctionDetailButton = ({ record }: AuctionDetailButtonProps) => {
  const { setCurrentAuction, toggleDetailFormVisible } = useAuctionListStore(
    state => pick(state, ['setCurrentAuction', 'toggleDetailFormVisible'])
  )

  const handleClick = () => {
    setCurrentAuction(record)
    toggleDetailFormVisible(true)
  }

  return (
    <Button type='link' onClick={handleClick}>
      查看详情
    </Button>
  )
}
